import { Component } from "react";
import { DatePicker as Datepicker } from "@fluentui/react-datepicker-compat";
import moment, { Moment } from "moment";
import "./DatePickerPresentation.scss";

interface DatePickerProps {
  value: Moment;
  onChange: (date: Moment) => void;
  minDate?: Moment;
  maxDate?: Moment;
  context?: any;
  className?: string;
}

class DatePicker extends Component<DatePickerProps> {
  onDateChange = (date: Date | null | undefined) => {
    if (!this.props.onChange || !date) {
      return;
    }
    let newDate = moment(new Date(date));
    this.props.onChange(newDate);
  };

  render() {
    const date = this.props.value.toDate();
    let minDate = this.props.minDate ? this.props.minDate.toDate() : undefined;
    let maxDate = this.props.maxDate ? this.props.maxDate.toDate() : undefined;
    return (
      <div>
        <Datepicker
          className="datepicker"
          minDate={minDate}
          maxDate={maxDate}
          value={date}
          onSelectDate={this.onDateChange}
        />
      </div>
    );
  }
}

export default DatePicker;
